(() => {
  const SOLID = "is-solid", LOCK = "search-focus-lock";

  function initAdaptive() {
    const header = document.querySelector("sticky-header.header--adaptive");
    if (!header) return;
    const searchbar = header.querySelector(".header__searchbar");
    if (!searchbar) return;
    const input = searchbar.querySelector("input");
    if (!input) return;
    // Lock the overlay on FOCUS only. Locking on pointerdown repositioned the
    // input before the tap's focus landed — that cost a second tap and dropped
    // the caret (and left the input white-on-white). Focus fires on the first
    // tap and survives the CSS reposition, so the caret + dark styling stay.
    input.addEventListener("focus", () => {
      header.classList.add(LOCK);
      header.classList.add(SOLID);
    });
  }

  function initInPageSearch() {
    const body = document.body;
    if (!body.classList.contains("template--product") &&
        !body.classList.contains("template--collection") &&
        !body.classList.contains("template--index")) return;
    const header = document.querySelector("sticky-header.header");
    if (!header) return;
    const searchbar = header.querySelector(".header__searchbar");
    const summary = document.querySelector(".header__utils__item--search summary");
    if (!searchbar || !summary) return;
    const input = searchbar.querySelector('input[type="search"]');
    input && summary.addEventListener("click", event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.focus({ preventScroll: true });
      header.classList.add(LOCK);
      let tries = 5;
      const retry = () => {
        document.activeElement !== input && tries-- > 0 &&
          (input.focus({ preventScroll: true }), setTimeout(retry, 120));
      };
      requestAnimationFrame(retry);
    }, true);
  }

  function init() { initAdaptive(); initInPageSearch(); }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
